import React from 'react';
import { Alert, Box, Stack, Typography } from '@mui/material';
import { SDialog } from '@modules/ui-components';
import type { BillingBlockPayload } from '../types';
import { getBillingBlockCopy } from './billingBlockCopy';

export interface BillingRequiredDialogProps {
  open: boolean;
  billingBlock: BillingBlockPayload | null;
  actionLabel?: string;
  onClose: () => void;
  onPrimary?: () => void;
}

export function BillingRequiredDialog({
  open,
  billingBlock,
  actionLabel,
  onClose,
  onPrimary,
}: BillingRequiredDialogProps): React.ReactElement | null {
  if (!billingBlock) return null;
  const copy = getBillingBlockCopy(billingBlock);
  return (
    <SDialog
      open={open}
      onClose={onClose}
      title={copy.title}
      maxWidth="sm"
      fullWidth
      showCloseButton={false}
      primaryAction={copy.primaryLabel && onPrimary ? {
        label: copy.primaryLabel,
        onClick: onPrimary,
      } : undefined}
      secondaryAction={{
        label: copy.secondaryLabel,
        onClick: onClose,
      }}
      data-testid="billing-required-dialog"
    >
      <Box sx={{ px: 3 }}>
        <Stack spacing={2}>
          {actionLabel && (
            <Typography variant="subtitle2" color="text.secondary">
              {actionLabel}
            </Typography>
          )}
          <Typography variant="body1">{copy.body}</Typography>
          {billingBlock.reason && (
            <Alert severity="info">
              {billingBlock.reason}
            </Alert>
          )}
        </Stack>
      </Box>
    </SDialog>
  );
}
